<template>
  <div class="my-5 mx-4">
    <div>
      <h1 class="text-center font-weight-light">
        JDT SERVICES QUARTERLY PROGRESS REPORT
      </h1>
      <p class="text-center caption">(DS-JDT-02)</p>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" dark color="success">
      {{ text }}
    </v-snackbar>

    <v-card class="pa-4" outlined flat>
      <v-card-actions>
        <v-row>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn
            small
            color="blue-grey"
            dark
            class="mr-1"
            :loading="isDownloading"
            @click="download"
          >
            generate pdf
          </v-btn>
          <v-btn
            small
            color="success"
            dark
            :loading="isSaving"
            @click="onSaveItem"
          >
            save changes
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>

    <FormSheet ref="reports" :items="forms" />
  </div>
</template>

<script>
/*eslint-disable */
import { mapActions } from "vuex";
import download from "downloadjs";
import FormSheet from "./FormSheet";

export default {
  components: {
    FormSheet,
  },
  data() {
    return {
      forms: {
        months: [{}],
        scopeObjectives: [{}],
        currentMedication: [{}],
        medicationChange: [{}],
      },
      isDownloading: false,
      isSaving: false,
      snackbar: false,
      text: "Successfully Saved",
      timeout: 1000,
    };
  },

  created() {
    this.fetch();
  },

  methods: {
    ...mapActions("dataTracking", [
      "getJDTProgressReportPDF",
      "createDataTracking",
      "getDataTracking",
    ]),

    async download() {
      this.isDownloading = true;
      this.items = this.$refs.reports.getData();

      const result = await this.getJDTProgressReportPDF(this.items);

      let pdfFile =
        "data:application/octet-stream;base64," + result.data.result;

      let fileName = `DS-JDT-02-${Date.now()}.pdf`;

      download(pdfFile, fileName, "application/pdf");
      this.isDownloading = false;
    },

    async onSaveItem() {
      this.isSaving = true;
      this.items = this.$refs.reports.getItems();
      const data = {
        data: this.items,
        params: {
          clientId: this.$route.params.clientID,
          staffId: localStorage.getItem("staffId"),
          type: "JDTQuarterly",
        },
      };

      await this.createDataTracking(data);
      this.isSaving = false;
      this.snackbar = true;
    },

    async fetch() {
      const response = await this.getDataTracking({
        clientId: this.$route.params.clientID,
        staffId: localStorage.getItem("staffId"),
      });

      const hasForm = !!response.result?.forms?.JDTQuarterly;

      if (hasForm) {
        this.forms = response.result.forms.JDTQuarterly;
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}
</style>
